import axios, { AxiosRequestConfig } from 'axios';
import buildLog from './utils/buildLog';
import getApiHostName from './utils/getApiHostName';
import Options from './utils/Options';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function log(level: string, message: string, details: any = null, id: string = null, correlationId: string = null): void {
  const entity = buildLog(level, message, details, id, correlationId);
  const requestConfig: AxiosRequestConfig = {};
  requestConfig.data = Options.Instance();
  // eslint-disable-next-line no-void
  void axios.post(`${getApiHostName()}/log`, entity, requestConfig);
}
